import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const termsData = [
  {
    title: 'قبول الشروط والاستخدام',
    text: 'باستخدامك لاستراحة شاشتنا سواء عبر تطبيق الويب أو تطبيق الجوال، فإنك توافق على الالتزام بجميع الشروط والأحكام الواردة في هذه الوثيقة. إذا كنت لا توافق على أي من هذه الشروط، يرجى التوقف عن استخدام الاستراحة فوراً. نحتفظ بالحق في تعديل هذه الشروط في أي وقت مع إشعار مسبق للمستخدمين.',
  },
  {
    title: 'حقوق الملكية الفكرية والمحتوى',
    text: 'جميع المحتويات المتاحة على استراحة شاشتنا، بما تشمل الأفلام والمسلسلات والبودكاست والصور والنصوص والشعارات، محمية بموجب قوانين حقوق الملكية الفكرية المعمول بها. يُحظر تماماً نسخ أو توزيع أو إعادة بث أي محتوى من الاستراحة دون الحصول على إذن كتابي مسبق من الشركة.',
  },
  {
    title: 'سياسة الاستخدام المقبول',
    text: 'يلتزم المستخدم باستخدام الاستراحة للأغراض المشروعة والمقبولة فقط. يُحظر استخدام الاستراحة لأي نشاط غير قانوني أو مسيء أو ضار. كما يُحظر محاولة اختراق أو تعطيل الخوادم أو الشبكات المرتبطة بالاستراحة، أو انتحال هوية شخص آخر، أو نشر محتوى مضلل أو مسيء.',
  },
  {
    title: 'حدود المسؤولية والضمانات',
    text: 'تُقدَّم خدمات استراحة شاشتنا  "كما هي" دون أي ضمانات صريحة أو ضمنية. لا تتحمل الشركة المسؤولية عن أي أضرار مباشرة أو غير مباشرة ناجمة عن استخدام الاستراحة أو عدم إمكانية الوصول إليها. الشركة غير مسؤولة عن جودة الشبكة المحلية التي يوفرها طرف ثالث.',
  },
  {
    title: 'إنهاء الخدمة والتعديلات',
    text: 'تحتفظ الشركة بالحق في إيقاف أو تعليق أو إنهاء وصول أي مستخدم أو مزود شبكة يخالف هذه الشروط، وذلك دون إشعار مسبق. كما تحتفظ الشركة بحق تعديل أو إيقاف أي جزء من الخدمة مؤقتاً أو دائماً لأغراض الصيانة أو التطوير.',
  },
];

const privacyData = [
  {
    title: 'البيانات التي نجمعها',
    text: 'نجمع معلومات أساسية لتحسين تجربتك مع الاستراحة، وتشمل: معلومات الاستخدام مثل المحتوى الذي تشاهده ومدة المشاهدة، وبيانات الجهاز مثل نوع المتصفح ونظام التشغيل، وعنوان IP ضمن الشبكة المحلية. لا نجمع أي معلومات شخصية حساسة دون موافقتك الصريحة.',
  },
  {
    title: 'كيفية استخدام بياناتك',
    text: 'نستخدم البيانات المجمعة لأغراض محددة تشمل: تحسين جودة خدماتنا وتجربة المستخدم، وتخصيص توصيات المحتوى وفقاً لتفضيلاتك، وتحليل أداء الاستراحة وإصلاح الأخطاء التقنية، وإعداد تقارير إحصائية مجهولة الهوية لمزودي الشبكة لمساعدتهم في تحسين خدماتهم.',
  },
  {
    title: 'مشاركة البيانات مع الأطراف الثالثة',
    text: 'نلتزم بعدم بيع أو تأجير بياناتك الشخصية لأي طرف ثالث تحت أي ظرف. قد نشارك بيانات إحصائية مجهولة الهوية مع شركائنا من مزودي الشبكة المحلية لأغراض تحسين الخدمة فقط. في حالات نادرة، قد نكشف عن معلومات إذا طُلب منا ذلك بموجب أمر قانوني.',
  },
  {
    title: 'أمان وحماية بياناتك',
    text: 'نطبق أعلى معايير الأمان لحماية بياناتك، بما يشمل: التشفير الكامل للبيانات أثناء النقل والتخزين باستخدام بروتوكول SSL/TLS، وجدران حماية متعددة الطبقات، وإجراءات صارمة للتحكم في الوصول الداخلي، ومراجعات أمنية دورية من قِبل خبراء متخصصين.',
  },
  {
    title: 'حقوقك كمستخدم',
    text: 'تتمتع بجميع الحقوق المقررة قانوناً فيما يخص بياناتك الشخصية، وتشمل: حق الاطلاع على البيانات التي نحتفظ بها عنك، وحق تصحيح أي بيانات غير دقيقة، وحق طلب حذف بياناتك نهائياً، وحق الاعتراض على معالجة بياناتك لأغراض معينة. للممارسة أي من هذه الحقوق، تواصل معنا عبر privacy@shashatana.ye.',
  },
];

function TermsPolicy() {
  const [activeTab, setActiveTab] = useState('terms');

  return (
    <>
      {/* Page Hero */}
      <section className="page-hero">
        <div className="bg-blobs">
          <div className="blob blob-1" />
          <div className="blob blob-2" />
        </div>
        <div className="grid-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <span className="page-hero-badge">📋 الشروط والسياسات</span>
          <h1 className="page-hero-title">
            الشروط{' '}
            <span className="gradient-text">والسياسات</span>
            <br />
            القانونية
          </h1>
          <p className="page-hero-subtitle">
            نلتزم بالشفافية الكاملة مع مستخدمينا وشركائنا. اقرأ هذه الوثائق
            بعناية لفهم حقوقك والتزاماتك عند استخدام استراحة شاشتنا في اليمن وصنعاء.
          </p>
        </div>
      </section>

      <div className="divider" />

      {/* Tab Navigation */}
      <section className="section section-alt" style={{ paddingBottom: 0 }}>
        <div className="dot-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div
            style={{
              display: 'flex',
              gap: 'var(--spacing-sm)',
              justifyContent: 'center',
              flexWrap: 'wrap',
              marginBottom: 'var(--spacing-3xl)',
            }}
          >
            {[
              { id: 'terms', label: '📜 شروط الخدمة' },
              { id: 'privacy', label: '🔒 سياسة الخصوصية' },
              { id: 'cookies', label: '🍪 سياسة الكوكيز' },
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: '0.7rem 1.5rem',
                  borderRadius: 'var(--radius-full)',
                  fontFamily: 'var(--font-family)',
                  fontWeight: '700',
                  fontSize: '0.95rem',
                  cursor: 'pointer',
                  transition: 'all var(--transition-normal)',
                  border: activeTab === tab.id
                    ? 'none'
                    : '1px solid var(--border-glass)',
                  background: activeTab === tab.id
                    ? 'linear-gradient(135deg, #8b5cf6 0%, #06b6d4 100%)'
                    : 'var(--bg-card)',
                  color: activeTab === tab.id
                    ? 'white'
                    : 'var(--text-secondary)',
                  boxShadow: activeTab === tab.id
                    ? 'var(--shadow-glow-purple)'
                    : 'none',
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Terms of Service */}
      {activeTab === 'terms' && (
        <section className="section section-alt" style={{ paddingTop: 0 }}>
          <div className="container" style={{ position: 'relative', zIndex: 1 }}>
            <div className="legal-content">
              <div className="legal-section">
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'var(--spacing-md)',
                    marginBottom: 'var(--spacing-xl)',
                  }}
                >
                  <div
                    style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: 'var(--radius-md)',
                      background: 'linear-gradient(135deg, #8b5cf6 0%, #06b6d4 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.5rem',
                      flexShrink: 0,
                    }}
                  >
                    📜
                  </div>
                  <div>
                    <h2 className="legal-section-title" style={{ marginBottom: 0 }}>
                      شروط الخدمة
                    </h2>
                    <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>
                      يُرجى قراءة هذه الشروط بعناية قبل استخدام الاستراحة
                    </p>
                  </div>
                </div>

                <div className="legal-items">
                  {termsData.map((item, index) => (
                    <div className="legal-item" key={index}>
                      <div className="legal-item-number">{index + 1}</div>
                      <div className="legal-item-content">
                        <h4 className="legal-item-title">{item.title}</h4>
                        <p className="legal-item-text">{item.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="last-updated">
                <strong>📅 آخر تحديث لشروط الخدمة:</strong> 4 يوليو 2026
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Privacy Policy */}
      {activeTab === 'privacy' && (
        <section className="section section-alt" style={{ paddingTop: 0 }}>
          <div className="container" style={{ position: 'relative', zIndex: 1 }}>
            <div className="legal-content">
              <div className="legal-section">
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'var(--spacing-md)',
                    marginBottom: 'var(--spacing-xl)',
                  }}
                >
                  <div
                    style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: 'var(--radius-md)',
                      background: 'linear-gradient(135deg, #8b5cf6 0%, #06b6d4 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.5rem',
                      flexShrink: 0,
                    }}
                  >
                    🔒
                  </div>
                  <div>
                    <h2 className="legal-section-title" style={{ marginBottom: 0 }}>
                      سياسة الخصوصية
                    </h2>
                    <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>
                      خصوصيتك تهمنا — إليك كيف نحمي بياناتك
                    </p>
                  </div>
                </div>

                <div className="legal-items">
                  {privacyData.map((item, index) => (
                    <div className="legal-item" key={index}>
                      <div
                        className="legal-item-number"
                        style={{
                          background: 'linear-gradient(135deg, #06b6d4 0%, #10b981 100%)',
                        }}
                      >
                        {index + 1}
                      </div>
                      <div className="legal-item-content">
                        <h4 className="legal-item-title">{item.title}</h4>
                        <p className="legal-item-text">{item.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="last-updated">
                <strong>📅 آخر تحديث لسياسة الخصوصية:</strong> 4 يوليو 2026
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Cookie Policy */}
      {activeTab === 'cookies' && (
        <section className="section section-alt" style={{ paddingTop: 0 }}>
          <div className="container" style={{ position: 'relative', zIndex: 1 }}>
            <div className="legal-content">
              <div className="legal-section">
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'var(--spacing-md)',
                    marginBottom: 'var(--spacing-xl)',
                  }}
                >
                  <div
                    style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: 'var(--radius-md)',
                      background: 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.5rem',
                      flexShrink: 0,
                    }}
                  >
                    🍪
                  </div>
                  <div>
                    <h2 className="legal-section-title" style={{ marginBottom: 0 }}>
                      سياسة ملفات تعريف الارتباط (الكوكيز)
                    </h2>
                    <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>
                      كيف نستخدم الكوكيز لتحسين تجربتك
                    </p>
                  </div>
                </div>

                <div className="cookie-box" style={{ marginBottom: 'var(--spacing-xl)' }}>
                  <span className="cookie-icon">ℹ️</span>
                  <p className="cookie-text">
                    <strong style={{ color: 'var(--text-primary)' }}>
                      ما هي ملفات تعريف الارتباط؟
                    </strong>
                    <br />
                    ملفات تعريف الارتباط (Cookies) هي ملفات نصية صغيرة تُخزَّن
                    على جهازك عند زيارة موقعنا. تساعدنا هذه الملفات في تذكر
                    تفضيلاتك وتحسين تجربتك في الزيارات المستقبلية.
                  </p>
                </div>

                {[
                  {
                    title: 'الكوكيز الضرورية',
                    icon: '⚙️',
                    text: 'هذه الكوكيز ضرورية لعمل الاستراحة بشكل صحيح ولا يمكن إيقافها. تشمل كوكيز حفظ جلسة تسجيل الدخول وتفضيلات اللغة والإعدادات الأساسية. لا تُستخدم هذه الكوكيز لأي أغراض تسويقية.',
                    color: 'rgba(139, 92, 246, 0.1)',
                    border: 'rgba(139, 92, 246, 0.2)',
                  },
                  {
                    title: 'كوكيز الأداء والتحليل',
                    icon: '📊',
                    text: 'نستخدم هذه الكوكيز لفهم كيفية تفاعل المستخدمين مع الاستراحة، مثل الصفحات الأكثر زيارة ومدة البقاء. جميع البيانات مجهولة الهوية وتُستخدم فقط لتحسين أداء الاستراحة وتجربة المستخدم.',
                    color: 'rgba(6, 182, 212, 0.1)',
                    border: 'rgba(6, 182, 212, 0.2)',
                  },
                  {
                    title: 'كوكيز التفضيلات والتخصيص',
                    icon: '🎨',
                    text: 'تُمكّننا هذه الكوكيز من تذكر تفضيلاتك مثل جودة الفيديو المفضلة ولغة الواجهة وآخر محتوى شاهدته، لتوفير تجربة مشاهدة مخصصة ومريحة في كل مرة تستخدم فيها الاستراحة.',
                    color: 'rgba(245, 158, 11, 0.1)',
                    border: 'rgba(245, 158, 11, 0.2)',
                  },
                  {
                    title: 'التحكم في الكوكيز وإدارتها',
                    icon: '🎛️',
                    text: 'يمكنك التحكم الكامل في ملفات تعريف الارتباط من خلال إعدادات متصفحك. يمكنك قبول أو رفض أو حذف الكوكيز في أي وقت. تجدر الإشارة إلى أن تعطيل بعض الكوكيز قد يؤثر على عمل بعض ميزات الاستراحة.',
                    color: 'rgba(16, 185, 129, 0.1)',
                    border: 'rgba(16, 185, 129, 0.2)',
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="legal-item"
                    style={{
                      background: item.color,
                      borderColor: item.border,
                      marginBottom: 'var(--spacing-md)',
                    }}
                  >
                    <div
                      className="legal-item-number"
                      style={{
                        background: 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)',
                        fontSize: '1.2rem',
                        width: '40px',
                        height: '40px',
                      }}
                    >
                      {item.icon}
                    </div>
                    <div className="legal-item-content">
                      <h4 className="legal-item-title">{item.title}</h4>
                      <p className="legal-item-text">{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="last-updated">
                <strong>📅 آخر تحديث لسياسة الكوكيز:</strong> 4 يوليو 2026
              </div>
            </div>
          </div>
        </section>
      )}

      <div className="divider" />

      {/* Bottom CTA */}
      <section className="cta-banner section">
        <div className="bg-blobs" style={{ opacity: 0.3 }}>
          <div className="blob blob-1" />
          <div className="blob blob-2" />
        </div>
        <div className="dot-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="cta-banner-inner">
            <div style={{ fontSize: '3rem', marginBottom: 'var(--spacing-lg)' }}>
              ⚖️
            </div>
            <h2 className="cta-banner-title">
              هل لديك{' '}
              <span className="gradient-text">استفسار قانوني؟</span>
            </h2>
            <p className="cta-banner-subtitle">
              إذا كان لديك أي سؤال حول شروط الخدمة أو سياسة الخصوصية أو
              أي مسألة قانونية أخرى، فريقنا جاهز للمساعدة.
            </p>
            <div className="cta-buttons">
              <Link to="/support" className="btn-primary">
                <span>💬</span>
                <span>تواصل مع فريقنا</span>
              </Link>
              <a
                href="mailto:shashatana.ye@gmail.com"
                className="btn-outline"
              >
                <span>✉️</span>
                <span>shashatana.ye@gmail.com</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TermsPolicy;